import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login-page-hero" }, null, -1)
const _hoisted_3 = { class: "image-group" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "auth-page-tag" }, "Data migration tool for Opendock", -1)

import logo from '@/../public/images/opendock_loadsmart_logo.png';

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthHero',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "opendock-logo",
        src: _unref(logo)
      }, null, 8, _hoisted_4)
    ]),
    _hoisted_5
  ]))
}
}

})